module.exports = __webpack_public_path__ + "img/20_16.631bc97a.png";